import * as React from "react";
const GithubIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    {...props}
  >
    <path
      stroke="#F9F9FC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18.513 26v-3.296a3.775 3.775 0 0 0-.223-1.615 3.856 3.856 0 0 0-.886-1.383C21.108 19.305 25 17.938 25 11.667a6.16 6.16 0 0 0-1.77-4.307 5.681 5.681 0 0 0-.105-4.33s-1.392-.401-4.612 1.7a16.218 16.218 0 0 0-8.257 0c-3.22-2.101-4.611-1.7-4.611-1.7a5.68 5.68 0 0 0-.107 4.33 6.16 6.16 0 0 0-1.769 4.342c0 6.224 3.893 7.591 7.596 8.039-.388.39-.687.856-.878 1.367a3.778 3.778 0 0 0-.23 1.596V26m0-2.297c-3.539 1.117-6.488 0-8.257-3.445"
    />
  </svg>
);
export default GithubIcon;
